import React from 'react'
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer'

const pdfStyles = StyleSheet.create({
    page: { padding: 20, fontSize: 9, fontFamily: 'Helvetica' },
    header: { backgroundColor: '#1a472a', padding: 10, marginBottom: 15, textAlign: 'center' },
    headerTitle: { color: 'white', fontSize: 15, fontWeight: 'bold' },
    headerSubtitle: { color: '#e0e0e0', fontSize: 10 },
    headerDate: { color: '#e0e0e0', fontSize: 8, marginTop: 4 },
    sectionTitle: { fontSize: 12, fontWeight: 'bold', backgroundColor: '#f0f0f0', padding: 6, borderWidth: 1, borderColor: '#cccccc', marginTop: 10, marginBottom: 0 },
    table: { width: '100%', marginBottom: 14, borderWidth: 1, borderColor: '#cccccc' },
    tableHeader: { backgroundColor: '#e8f5e9', flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#2e7d32', paddingVertical: 5 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 0.5, borderBottomColor: '#dddddd', paddingVertical: 4 },
    colSno: { width: '8%', paddingLeft: 4, paddingRight: 2, fontWeight: 'bold' },
    colParticulars: { width: '50%', paddingLeft: 4, paddingRight: 4 },
    colStatus: { width: '16%', paddingLeft: 4, paddingRight: 4 },
    colRemarks: { width: '26%', paddingLeft: 4, paddingRight: 4 },
    halfCell: { width: '50%', paddingLeft: 4, paddingRight: 4 },
    statusSuccess: { color: '#2e7d32', fontWeight: 'bold' },
    statusError: { color: '#d32f2f', fontWeight: 'bold' },
    footer: { marginTop: 18, textAlign: 'center', fontSize: 8, color: '#666666', borderTopWidth: 1, borderTopColor: '#cccccc', paddingTop: 8 },
})

const getValue = (source = {}, ...keys) => {
    for (const key of keys) {
        const value = source?.[key]
        if (value !== undefined && value !== null && value !== '') {
            return value
        }
    }
    return ''
}

const getDetailValue = (source = {}, ...keys) => getValue(source, ...keys)

const formatPlain = (value) => {
    if (value === undefined || value === null || value === '') return '-'
    if (value === true) return 'Yes'
    if (value === false) return 'No'
    return String(value)
}

const formatYesNo = (value) => {
    if (value === undefined || value === null || value === '') return '-'
    if (value === true || value === 'Yes' || value === 'YES') return 'Yes'
    if (value === false || value === 'No' || value === 'NO') return 'No'
    return String(value)
}

const formatCurrency = (value) => {
    const plain = formatPlain(value)
    return plain === '-' ? plain : `Rs. ${plain}`
}

const formatDate = (value) => {
    if (!value) return '-'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return formatPlain(value)
    return date.toLocaleDateString('en-GB')
}

const buildRows = (BasicDetails = {}) => ({
    registrationRows: [
        {
            sno: '1.1',
            particulars: 'Whether the Registration and processing fee paid (Rs 50,000.) (please see counter foil of the receipt of the bank)',
            status: BasicDetails.isfee_paid,
            remarks: getValue(BasicDetails, 'regfee_remarks'),
            yesNo: true,
        },
    ],
    sponsoringSocietyRows: [
        { sno: 'a', particulars: 'Whether the Society is registered under societies registration act', status: BasicDetails.issociety_registered, remarks: getValue(BasicDetails, 'society_registered_remarks'), yesNo: true },
        { sno: 'b', particulars: 'Whether the Bye-laws of the Society is enclosed', status: BasicDetails.isbye_laws_enclosed, remarks: getValue(BasicDetails, 'bye_laws_remarks'), yesNo: true },
        { sno: 'c', particulars: 'The college is located in', status: BasicDetails.location_type, remarks: getValue(BasicDetails, 'location_remarks') },
        { sno: 'd', particulars: 'Whether the Proposed college is in the list of identified location / Mandal', status: BasicDetails.isidentified_location, remarks: getValue(BasicDetails, 'identified_location_remarks'), yesNo: true },
        { sno: 'e', particulars: 'Whether any other Educational Institution is run by the applicant Society', status: BasicDetails.isother_educational_institution, remarks: getValue(BasicDetails, 'other_institution_remarks'), yesNo: true },
        { sno: 'f', particulars: 'If yes, any such existing Degree College is being run in temporary premises /building on lease/rent beyond 10 years', status: BasicDetails.istemporary_premises_beyond_ten_years, remarks: getValue(BasicDetails, 'temporary_premises_beyond_ten_years_remarks'), yesNo: true },
        { sno: 'g', particulars: 'Whether any member of the Society/ College has been convicted for any criminal offence or has held a record of criminal behavior', status: getDetailValue(BasicDetails, 'iscriminal_behavior', 'isCriminalBehavior'), remarks: getValue(BasicDetails, 'criminal_behavior_remarks', 'criminalBehaviorRemarks'), yesNo: true },
        { sno: 'h', particulars: 'Whether the Management / Society is running any un-recognized college(s) and whether it has fulfilled all the conditions of affiliation by UGC / Govt. from time to time', status: getDetailValue(BasicDetails, 'isugc_recognition', 'isUgcRecognition'), remarks: getValue(BasicDetails, 'ugc_recognition_remarks', 'ugcRecognitionRemarks'), yesNo: true },
        { sno: 'i', particulars: 'Whether any dues or complaints are pending against the Management / Society / College', status: getDetailValue(BasicDetails, 'ispending_dues_or_complaints', 'isPendingDuesOrComplaints'), remarks: getValue(BasicDetails, 'pending_dues_or_complaints_remarks', 'pendingDuesOrComplaintsRemarks'), yesNo: true },
        { sno: 'j', particulars: 'Whether the Management / Society is eligible for starting of New Private Unaided Degree College as per the existing rules / norms / guidelines', status: getDetailValue(BasicDetails, 'iseligible_for_new_college', 'isEligibleForNewCollege'), remarks: getValue(BasicDetails, 'eligible_for_new_college_remarks', 'eligibleForNewCollegeRemarks'), yesNo: true },
    ],
    landRows: [
        { sno: '2.1', particulars: 'Whether the Society has own land as per norms', status: getDetailValue(BasicDetails, 'isown_land', 'isOwnLand'), remarks: getValue(BasicDetails, 'own_land_remarks', 'ownLandRemarks'), yesNo: true },
        { sno: '2.2', particulars: 'Whether the land deed is registered ownership document', status: getDetailValue(BasicDetails, 'island_deed', 'isLandDeed'), remarks: getValue(BasicDetails, 'land_deed_remarks', 'landDeedRemarks'), yesNo: true },
        { sno: '2.3', particulars: 'Whether the land is in the name of the Society', status: getDetailValue(BasicDetails, 'island_in_society_name', 'isLandInSocietyName'), remarks: getValue(BasicDetails, 'land_in_society_name_remarks', 'landInSocietyNameRemarks'), yesNo: true },
        { sno: '2.4', particulars: 'Whether the own land is in the same Mandal', status: getDetailValue(BasicDetails, 'island_in_same_mandal', 'isLandInSameMandal'), remarks: getValue(BasicDetails, 'land_in_same_mandal_remarks', 'landInSameMandalRemarks'), yesNo: true },
        { sno: '2.5', particulars: 'Whether the sketch plan of own land drawn by the licensed surveyor and attested by the MRO is produced', status: getDetailValue(BasicDetails, 'island_sketch_plan', 'isLandSketchPlan'), remarks: getValue(BasicDetails, 'land_sketch_plan_remarks', 'landSketchPlanRemarks'), yesNo: true },
        { sno: '2.6', particulars: 'Whether the schedule of property mentioned in the registered ownership deed is tallying with the sketch plan produced', status: getDetailValue(BasicDetails, 'island_schedule_tally', 'isLandScheduleTally'), remarks: getValue(BasicDetails, 'land_schedule_tally_remarks', 'landScheduleTallyRemarks'), yesNo: true },
    ],
    buildingRows: [
        { sno: '3.1', particulars: 'Whether the building deed is in the name of the college / society', status: getDetailValue(BasicDetails, 'isbuilding_deed', 'isBuildingDeed'), remarks: getValue(BasicDetails, 'building_deed_remarks', 'buildingDeedRemarks'), yesNo: true },
        { sno: '3.2', particulars: 'Whether the building plan is approved by the competent authority', status: getDetailValue(BasicDetails, 'isbuilding_plan', 'isBuildingPlan'), remarks: getValue(BasicDetails, 'building_plan_remarks', 'buildingPlanRemarks'), yesNo: true },
        { sno: '3.2a', particulars: 'Competent authority designation', status: '-', remarks: getValue(BasicDetails, 'competent_authority_designation_remarks', 'competentAuthorityDesignation', 'competentAuthorityDesignationRemarks') },
        { sno: '3.3', particulars: 'Whether the approved plan of the building drawn by the licensed surveyor and attested by the Principal of a Government College is produced', status: getDetailValue(BasicDetails, 'isapproved_plan_produced', 'isApprovedPlanProduced'), remarks: getValue(BasicDetails, 'approved_plan_produced_remarks', 'approvedPlanProducedRemarks'), yesNo: true },
        { sno: '3.4', particulars: 'Whether the schedule of the building is tallying with the approved plan', status: getDetailValue(BasicDetails, 'isbuilding_schedule_tally', 'isBuildingScheduleTally'), remarks: getValue(BasicDetails, 'building_schedule_tally_remarks', 'buildingScheduleTallyRemarks'), yesNo: true },
        { sno: '3.5', particulars: 'Whether the carpet area of the building is as per norms', status: getDetailValue(BasicDetails, 'isbuilding_carpet_area_as_per_norms', 'isBuildingCarpetAreaAsPerNorms'), remarks: getValue(BasicDetails, 'building_carpet_area_as_per_norms_remarks', 'buildingCarpetAreaAsPerNormsRemarks'), yesNo: true },
        { sno: '3.6', particulars: 'Whether a copy of the construction permission order for leased building issued by the competent authority is uploaded', status: getDetailValue(BasicDetails, 'isconstruction_permission_order', 'isConstructionPermissionOrder'), remarks: getValue(BasicDetails, 'construction_permission_order_remarks', 'constructionPermissionOrderRemarks'), yesNo: true },
        { sno: '3.7', particulars: 'Whether the location of the building is in accordance with the norms as per the information given in the application (w.r.t. radius of 500 mts., from cinema halls, wines shops, public function halls, whether in flats / sheds/ abandoned go-downs / commercial complexes /thatched houses. etc.,)', status: getDetailValue(BasicDetails, 'isbuilding_location_as_per_norms', 'isBuildingLocationAsPerNorms'), remarks: getValue(BasicDetails, 'building_location_as_per_norms_remarks', 'buildingLocationAsPerNormsRemarks'), yesNo: true },
        { sno: '3.8', particulars: 'Whether the Building Completion Certificate / Occupancy Certificate is uploaded', status: getDetailValue(BasicDetails, 'isbuilding_completion_certificate', 'isBuildingCompletionCertificate'), remarks: getValue(BasicDetails, 'building_completion_certificate_remarks', 'buildingCompletionCertificateRemarks'), yesNo: true },
        { sno: '3.9', particulars: 'Whether a copy of valid sanitary certificate is produced', status: getDetailValue(BasicDetails, 'issanitary_certificate', 'isSanitaryCertificate'), remarks: getValue(BasicDetails, 'sanitary_remarks', 'sanitaryRemarks'), yesNo: true },
        { sno: '3.10', particulars: 'Whether Geotagged photographs of the building', status: getDetailValue(BasicDetails, 'isgeotagged_photos', 'isGeotaggedPhotos'), remarks: getValue(BasicDetails, 'geo_photos_remarks', 'geoPhotosRemarks'), yesNo: true },
        { sno: '3.11', particulars: 'Whether any other Institution is running in the same building accommodation', status: getDetailValue(BasicDetails, 'isother_institution_in_same_building', 'isOtherInstitutionInSameBuilding'), remarks: getValue(BasicDetails, 'other_institution_in_same_building_remarks', 'otherInstitutionInSameBuildingRemarks'), yesNo: true },
        { sno: '3.12', particulars: 'Whether the details of existing building accommodation provided in Annexure-I are in accordance with the stipulated norms', status: getDetailValue(BasicDetails, 'isannexure_one_building_details', 'isAnnexureOneBuildingDetails'), remarks: getValue(BasicDetails, 'annexure_one_building_details_remarks', 'annexureOneBuildingDetailsRemarks'), yesNo: true },
    ],
    parkingRows: [
        { sno: 'a.', particulars: 'Whether the parking area is available in the same premises', status: getDetailValue(BasicDetails, 'isparking_in_same_premises', 'isParkingInSamePremises'), remarks: getValue(BasicDetails, 'parking_in_same_premises_remarks', 'parkingInSamePremisesRemarks', 'parkingSamePremisesRemarks'), yesNo: true },
        { sno: 'b.', particulars: 'Whether 20% of the total built up area is provided for the Parking area', status: getDetailValue(BasicDetails, 'isparking_built_up_area', 'isParkingBuiltUpArea'), remarks: getValue(BasicDetails, 'parking_built_up_area_remarks', 'parkingBuiltUpAreaRemarks'), yesNo: true },
        { sno: 'c.', particulars: 'If not in the same premises, whether the parking area provided within a distance of 100 meters thereof', status: getDetailValue(BasicDetails, 'isparking_within_hundred_meters', 'isParkingWithinHundredMeters'), remarks: getValue(BasicDetails, 'parking_within_hundred_meters_remarks', 'parkingWithinHundredMetersRemarks'), yesNo: true },
    ],
    playgroundRows: [
        { sno: 'a.', particulars: 'Whether the Playground facility is available in the same premises', status: getDetailValue(BasicDetails, 'isplayground_in_same_premises', 'isPlaygroundInSamePremises'), remarks: getValue(BasicDetails, 'playground_in_same_premises_remarks', 'playgroundInSamePremisesRemarks', 'playgroundSamePremisesRemarks'), yesNo: true },
        { sno: 'b.', particulars: 'If yes, mention the extent of the playground facility available (sft)', status: '-', remarks: getValue(BasicDetails, 'playground_extent_remarks', 'playgroundExtent', 'playgroundExtentRemarks') },
        { sno: 'c.', particulars: 'If not, whether any alternative arrangement for playground is provided within a radius of 5 kms along with bus facility', status: getDetailValue(BasicDetails, 'isalternative_playground_arrangement', 'isAlternativePlaygroundArrangement'), remarks: getValue(BasicDetails, 'alternative_playground_arrangement_remarks', 'alternativePlaygroundArrangementRemarks'), yesNo: true },
        { sno: 'd.', particulars: 'If yes, whether MoU for utilization of the alternative facility for playground is produced', status: getDetailValue(BasicDetails, 'isplayground_mou_produced', 'isPlaygroundMouProduced'), remarks: getValue(BasicDetails, 'playground_mou_produced_remarks', 'playgroundMouProducedRemarks'), yesNo: true },
    ],
    fireSafetyRows: [
        { sno: '3.16', particulars: 'Whether valid fire safety certificate / latest affidavit for exempted cases is produced', status: getDetailValue(BasicDetails, 'islatest_fire_safety_certificate', 'isLatestFireSafetyCertificate'), remarks: getValue(BasicDetails, 'latest_fire_safety_certificate_remarks', 'latestFireSafetyCertificateRemarks'), yesNo: true },
    ],
    financialRows: [
        { sno: '5.1', particulars: 'Total Financial Resource Amount required for starting the programmes', status: '-', remarks: formatCurrency(getDetailValue(BasicDetails, 'financial_resource_amount_required', 'financialResourceAmountRequired')) },
        { sno: '5.2', particulars: 'Whether the FDRs towards Financial Resources provided by the society is sufficient for sanctioning the programmes', status: getDetailValue(BasicDetails, 'isfinancial_resources_sufficient', 'isFinancialResourcesSufficient'), remarks: getValue(BasicDetails, 'financial_resources_sufficient_remarks', 'financialResourcesSufficientRemarks'), yesNo: true },
        { sno: 'a.', particulars: 'If "Not" total amount deficit', status: '-', remarks: formatCurrency(getDetailValue(BasicDetails, 'financial_resource_deficit', 'financialResourceDeficit')) },
        { sno: '5.3', particulars: 'Whether purpose "Towards Financial Resources to start a New Private Unaided Degree College" mentioned on the FDR enclosed', status: getDetailValue(BasicDetails, 'isfinancial_resource_purpose_mentioned', 'isFinancialResourcePurposeMentioned'), remarks: getValue(BasicDetails, 'financial_resource_purpose_mentioned_remarks', 'financialResourcePurposeMentionedRemarks'), yesNo: true },
    ],
    documentsRows: [
        { sno: '8.1', particulars: 'Whether the Detailed Project Report is uploaded', status: getDetailValue(BasicDetails, 'isdetailed_project_report_uploaded', 'isDetailedProjectReportUploaded'), remarks: getValue(BasicDetails, 'detailed_project_report_uploaded_remarks', 'detailedProjectReportUploadedRemarks'), yesNo: true },
        { sno: '8.2', particulars: 'Whether the Development Plan is uploaded', status: getDetailValue(BasicDetails, 'isdevelopment_plan_uploaded', 'isDevelopmentPlanUploaded'), remarks: getValue(BasicDetails, 'development_plan_uploaded_remarks', 'developmentPlanUploadedRemarks'), yesNo: true },
        { sno: '8.3', particulars: 'Whether the Architectural Master Plan is uploaded', status: getDetailValue(BasicDetails, 'isarchitectural_master_plan_uploaded', 'isArchitecturalMasterPlanUploaded'), remarks: getValue(BasicDetails, 'architectural_master_plan_uploaded_remarks', 'architecturalMasterPlanUploadedRemarks'), yesNo: true },
        { sno: '8.4', particulars: 'Whether the Structure of Academic Administrative Governance of the college is uploaded', status: getDetailValue(BasicDetails, 'isacademic_administrative_governance_uploaded', 'isAcademicAdministrativeGovernanceUploaded'), remarks: getValue(BasicDetails, 'academic_administrative_governance_uploaded_remarks', 'academicAdministrativeGovernanceUploadedRemarks'), yesNo: true },
        { sno: '8.5', particulars: 'Whether the sources of financing of capital and operating expenditure is uploaded', status: getDetailValue(BasicDetails, 'issources_of_financing_uploaded', 'isSourcesOfFinancingUploaded'), remarks: getValue(BasicDetails, 'sources_of_financing_uploaded_remarks', 'sourcesOfFinancingUploadedRemarks'), yesNo: true },
        { sno: '8.6', particulars: 'Whether the Policies with regard to faculty recruitment, retention, development, etc., are uploaded', status: getDetailValue(BasicDetails, 'isfaculty_policies_uploaded', 'isFacultyPoliciesUploaded'), remarks: getValue(BasicDetails, 'faculty_policies_uploaded_remarks', 'facultyPoliciesUploadedRemarks'), yesNo: true },
    ],
})

const ReportRow = ({ sno, particulars, status, remarks, yesNo = false }) => {
    const normalizedStatus = yesNo ? formatYesNo(status) : formatPlain(status)
    const statusStyle = yesNo && normalizedStatus === 'Yes'
        ? pdfStyles.statusSuccess
        : yesNo && normalizedStatus === 'No'
            ? pdfStyles.statusError
            : null

    return (
        <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.colSno}>{sno}</Text>
            <Text style={pdfStyles.colParticulars}>{particulars}</Text>
            <Text style={[pdfStyles.colStatus, statusStyle]}>{normalizedStatus}</Text>
            <Text style={pdfStyles.colRemarks}>{formatPlain(remarks)}</Text>
        </View>
    )
}

const renderSection = (title, rows = []) => {
    if (!rows.length) return null

    return (
        <React.Fragment key={title}>
            <Text style={pdfStyles.sectionTitle}>{title}</Text>
            <View style={pdfStyles.table}>
                <View style={pdfStyles.tableHeader}>
                    <Text style={pdfStyles.colSno}>S.No</Text>
                    <Text style={pdfStyles.colParticulars}>Particulars</Text>
                    <Text style={pdfStyles.colStatus}>Yes / No</Text>
                    <Text style={pdfStyles.colRemarks}>Remarks of the Scrutiny Committee</Text>
                </View>
                {rows.map((row, index) => (
                    <ReportRow key={`${title}-${index}`} {...row} />
                ))}
            </View>
        </React.Fragment>
    )
}

const renderSummaryTable = (title, items = []) => {
    if (!items.length) return null

    const rows = []
    for (let index = 0; index < items.length; index += 2) {
        rows.push(items.slice(index, index + 2))
    }

    return (
        <>
            <Text style={pdfStyles.sectionTitle}>{title}</Text>
            <View style={pdfStyles.table}>
                {rows.map((row, index) => (
                    <View key={`${title}-${index}`} style={pdfStyles.tableRow}>
                        <Text style={pdfStyles.halfCell}>{`${row[0]?.label || ''}: ${formatPlain(row[0]?.value)}`}</Text>
                        <Text style={pdfStyles.halfCell}>{row[1] ? `${row[1].label}: ${formatPlain(row[1].value)}` : ''}</Text>
                    </View>
                ))}
            </View>
        </>
    )
}

const renderUgProgrammes = (ugCourses = []) => {
    if (!ugCourses.length) return null

    return (
        <>
            <Text style={pdfStyles.sectionTitle}>4. Details of the Proposed UG programmes</Text>
            <View style={pdfStyles.table}>
                <View style={pdfStyles.tableHeader}>
                    <Text style={{ width: '15%', paddingLeft: 4 }}>Sl No.</Text>
                    <Text style={{ width: '60%', paddingLeft: 4 }}>Type of the UG Programme</Text>
                    <Text style={{ width: '25%', paddingLeft: 4 }}>Total No. of programmes</Text>
                </View>
                {ugCourses.map((program, index) => (
                    <View key={`ug-${index}`} style={pdfStyles.tableRow}>
                        <Text style={{ width: '15%', paddingLeft: 4 }}>{index + 1}.</Text>
                        <Text style={{ width: '60%', paddingLeft: 4 }}>{`${formatPlain(program.program_name)}${program.medium ? ` (${program.medium})` : ''}`}</Text>
                        <Text style={{ width: '25%', paddingLeft: 4 }}>1</Text>
                    </View>
                ))}
            </View>
        </>
    )
}

const renderCorpusTable = (corpusFundInstall = []) => {
    if (!corpusFundInstall.length) return null

    return (
        <>
            <Text style={pdfStyles.sectionTitle}>6. Corpus Fund for Proposed College / UG Programmes</Text>
            <View style={pdfStyles.table}>
                <View style={pdfStyles.tableHeader}>
                    <Text style={{ width: '8%', paddingLeft: 4 }}>Sl.</Text>
                    <Text style={{ width: '14%', paddingLeft: 4 }}>Programme</Text>
                    <Text style={{ width: '10%', paddingLeft: 4 }}>Amount</Text>
                    <Text style={{ width: '13%', paddingLeft: 4 }}>Period</Text>
                    <Text style={{ width: '10%', paddingLeft: 4 }}>FDR No.</Text>
                    <Text style={{ width: '9%', paddingLeft: 4 }}>Date</Text>
                    <Text style={{ width: '10%', paddingLeft: 4 }}>Bank</Text>
                    <Text style={{ width: '8%', paddingLeft: 4 }}>IFSC</Text>
                    <Text style={{ width: '10%', paddingLeft: 4 }}>Maturity Date</Text>
                    <Text style={{ width: '10%', paddingLeft: 4 }}>Renewal Date</Text>
                </View>
                {corpusFundInstall.map((fund, index) => (
                    <View key={`corpus-${index}`} style={pdfStyles.tableRow}>
                        <Text style={{ width: '8%', paddingLeft: 4 }}>{index + 1}.</Text>
                        <Text style={{ width: '14%', paddingLeft: 4 }}>{formatPlain(fund.programme)}</Text>
                        <Text style={{ width: '10%', paddingLeft: 4 }}>{formatPlain(fund.amount)}</Text>
                        <Text style={{ width: '13%', paddingLeft: 4 }}>{`${formatDate(fund.period_from)} - ${formatDate(fund.period_to)}`}</Text>
                        <Text style={{ width: '10%', paddingLeft: 4 }}>{formatPlain(fund.fdr_no)}</Text>
                        <Text style={{ width: '9%', paddingLeft: 4 }}>{formatDate(fund.date)}</Text>
                        <Text style={{ width: '10%', paddingLeft: 4 }}>{formatPlain(fund.bank_name)}</Text>
                        <Text style={{ width: '8%', paddingLeft: 4 }}>{formatPlain(fund.ifsc_code)}</Text>
                        <Text style={{ width: '10%', paddingLeft: 4 }}>{formatDate(fund.maturity_date)}</Text>
                        <Text style={{ width: '10%', paddingLeft: 4 }}>{formatDate(fund.renewal_date)}</Text>
                    </View>
                ))}
            </View>
        </>
    )
}

const renderFinalRemarksAndStatus = (BasicDetails = {}) => {
    return (
        <>
            <Text style={pdfStyles.sectionTitle}>Final Remarks & Status</Text>
            <View style={pdfStyles.table}>
                <View style={pdfStyles.tableHeader}>
                    <Text style={pdfStyles.colSno}>S.No</Text>
                    <Text style={{ width: '60%', paddingLeft: 4 }}>Particulars to be verified based on the documents enclosed to the application</Text>
                    <Text style={{ width: '30%', paddingLeft: 4 }}>Remarks of the Scrutiny Committee</Text>
                </View>
                <View style={pdfStyles.tableRow}>
                    <Text style={pdfStyles.colSno}></Text>
                    <Text style={{ width: '60%', paddingLeft: 4 }}>Final Remarks</Text>
                    <Text style={{ width: '30%', paddingLeft: 4 }}>{getDetailValue(BasicDetails, 'final_remarks', 'finalRemarks') || '-'}</Text>
                </View>
                <View style={pdfStyles.tableRow}>
                    <Text style={pdfStyles.colSno}></Text>
                    <Text style={{ width: '60%', paddingLeft: 4 }}>Final Status</Text>
                    <Text style={{ width: '30%', paddingLeft: 4 }}>{getDetailValue(BasicDetails, 'final_status', 'finalStatus') || '-'}</Text>
                </View>
            </View>
        </>
    )
}

const renderDeficiencies = (BasicDetails = {}, deficiencies = []) => {
    // Filter deficiencies with actual text content
    const validDeficiencies = (deficiencies || []).filter(
        (item) => item?.final_status || item?.deficiency || item?.remarks
    )

    if (getDetailValue(BasicDetails, 'final_status', 'finalStatus') !== 'DeficiencyIdentified' || !validDeficiencies.length) {
        return null
    }

    return (
        <>
            <Text style={[pdfStyles.sectionTitle, { backgroundColor: '#ffebee', color: '#c62828' }]}>Deficiencies Found</Text>
            <View style={pdfStyles.table}>
                <View style={pdfStyles.tableHeader}>
                    <Text style={{ width: '15%', paddingLeft: 4 }}>S.No</Text>
                    <Text style={{ width: '85%', paddingLeft: 4 }}>Deficiency Identified</Text>
                </View>
                {validDeficiencies.map((item, index) => {
                    const sno = index + 1
                    const deficiency = item?.final_status || item?.deficiency || item?.remarks || '-'
                    return (
                        <View key={`def-${index}`} style={pdfStyles.tableRow}>
                            <Text style={{ width: '15%', paddingLeft: 4 }}>{sno}</Text>
                            <Text style={{ width: '85%', paddingLeft: 4 }}>{deficiency}</Text>
                        </View>
                    )
                })}
            </View>
        </>
    )
}

export const ScrutinyPdfDocument = ({ BasicDetails = {}, MainDetails = {}, ugCourses = [], corpusFundInstall = [], deficiencies = [], collCode = '' }) => {
    console.log("Rendering ScrutinyPdfDocument with data:", { BasicDetails, MainDetails, ugCourses, corpusFundInstall, deficiencies, collCode })
    const rows = buildRows(BasicDetails)
    const societyDetails = [
        { label: 'Society Name', value: MainDetails.society_name },
        { label: 'Door No', value: MainDetails.society_door_no },
        { label: 'Street', value: MainDetails.society_street },
        { label: 'Mandal', value: MainDetails.society_mandal },
        { label: 'District', value: MainDetails.society_district },
        { label: 'Mobile', value: MainDetails.society_mobile },
    ]
    const collegeDetails = [
        { label: 'Proposed College Name', value: MainDetails.proposed_college_name },
        { label: 'Survey No', value: MainDetails.college_survey_no },
        { label: 'Door No', value: MainDetails.college_door_no },
        { label: 'Street', value: MainDetails.college_street },
        { label: 'Mandal', value: MainDetails.college_address_mandal },
        { label: 'District', value: MainDetails.college_address_district },
        { label: 'Mobile', value: MainDetails.college_mobile },
        { label: 'Email', value: MainDetails.college_email },
    ]

    return (
        <Document>
            <Page size="A4" style={pdfStyles.page}>
                <View style={pdfStyles.header}>
                    <Text style={pdfStyles.headerTitle}>{formatPlain(MainDetails.proposed_college_name || MainDetails.society_name || 'College')}</Text>
                    <Text style={pdfStyles.headerSubtitle}>Scrutiny Report for Starting of New Private Unaided Degree Colleges</Text>
                    <Text style={pdfStyles.headerDate}>Generated on {new Date().toLocaleDateString()}</Text>
                </View>

                {renderSummaryTable('Name of the Society and Address', societyDetails)}
                {renderSummaryTable('Name and address of the Proposed Degree College', collegeDetails)}
                {renderSection('1. Registration and Processing Fee', rows.registrationRows)}
                {renderSection('1.2 Sponsoring Society Details', rows.sponsoringSocietyRows)}
                {renderSection('2. Details of the Own Land', rows.landRows)}
                {renderSection('3. Building Accommodation', rows.buildingRows)}
                {renderSection('3.13 Parking Area', rows.parkingRows)}
                {renderSection('3.14 Playground', rows.playgroundRows)}
                {renderSection('3.16 Fire Safety', rows.fireSafetyRows)}
                {renderUgProgrammes(ugCourses)}
                {renderSection('5. Financial Resource', rows.financialRows)}
                {renderCorpusTable(corpusFundInstall)}
                {renderSection('7. NEW Programme Approval Fee', [{ sno: '7', particulars: 'NEW Programme Approval Fee', status: '-', remarks: formatCurrency(getDetailValue(BasicDetails, 'new_programme_approval_fee', 'newProgrammeApprovalFee')) }])}
                {renderSection('8. DPR and Other Relevant Documents', rows.documentsRows)}
                {renderFinalRemarksAndStatus(BasicDetails)}
                {renderDeficiencies(BasicDetails, deficiencies)}

                <View style={pdfStyles.footer}>
                    <Text>College Code: {formatPlain(collCode)} | This is a system-generated scrutiny report.</Text>
                </View>
            </Page>
        </Document>
    )
}

export const buildScrutinyPdfData = ({ clgDetails = {}, scrutinyData = {}, rowData = null }) => {
    const BasicDetails = Array.isArray(scrutinyData?.BasicDetails)
        ? (scrutinyData?.BasicDetails?.[0] || {})
        : (scrutinyData?.BasicDetails || {})
    const MainDetails = Array.isArray(clgDetails?.mainDetails)
        ? (clgDetails?.mainDetails?.[0] || {})
        : (clgDetails?.MainDetails || clgDetails?.mainDetails || {})
    const ugCourses = clgDetails?.ugPrograms || clgDetails?.ugCourses || []
    const corpusFundInstall = clgDetails?.corpusFundDetails || clgDetails?.corpusFundInstall || []
    const deficiencies = scrutinyData?.ScrutinyFinalStatus || scrutinyData?.deficiencies || []
    const collCode = rowData?.coll_code || MainDetails?.coll_code || ''

    return {
        BasicDetails,
        MainDetails,
        ugCourses,
        corpusFundInstall,
        deficiencies,
        collCode,
    }
}

export const openScrutinyPdfInNewTab = async ({ clgDetails, scrutinyData, rowData, previewWindow }) => {
    const pdfData = buildScrutinyPdfData({ clgDetails, scrutinyData, rowData })

    if (!Object.keys(pdfData.MainDetails || {}).length) {
        throw new Error('Scrutiny PDF data is not available')
    }

    const blob = await pdf(
        <ScrutinyPdfDocument
            BasicDetails={pdfData.BasicDetails}
            MainDetails={pdfData.MainDetails}
            ugCourses={pdfData.ugCourses}
            corpusFundInstall={pdfData.corpusFundInstall}
            deficiencies={pdfData.deficiencies}
            collCode={pdfData.collCode}
        />
    ).toBlob()

    const blobUrl = URL.createObjectURL(blob)

    if (previewWindow) {
        previewWindow.location.href = blobUrl
        return blobUrl
    }

    window.open(blobUrl, '_blank', 'noopener,noreferrer')
    return blobUrl
}

// export default function ScrutinityPdfGeneration({ clgDetails, scrutinyData, rowData, getOverallData }) {

//     const {
//         BasicDetails: scrutinyBasicDetails,
//         MainDetails: ClgMainDetails,
//         ugCourses: finalUgCourses,
//         corpusFundInstall: finalCorpusFund,
//         deficiencies: finalDeficiencies,
//         collCode: finalCollCode,
//     } = buildScrutinyPdfData({ clgDetails, scrutinyData, rowData })

//     const hasData = Object.keys(ClgMainDetails || {}).length > 0

//     if (!hasData) {
//         return null
//     }

//     return (
//         <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 1000 }}>
//             <PDFDownloadLink
//                 key={`${JSON.stringify(scrutinyBasicDetails)}-${JSON.stringify(ClgMainDetails)}-${finalUgCourses.length}-${finalCorpusFund.length}`}
//                 document={
//                     <ScrutinyPdfDocument
//                         BasicDetails={scrutinyBasicDetails}
//                         MainDetails={ClgMainDetails}
//                         ugCourses={finalUgCourses}
//                         corpusFundInstall={finalCorpusFund}
//                         deficiencies={finalDeficiencies}
//                         collCode={finalCollCode}
//                     />
//                 }
//                 fileName="new_college_scrutiny_report.pdf"
//                 style={{ background: '#2e7d32', color: 'white', border: 'none', padding: '12px 24px', borderRadius: 40, cursor: 'pointer', fontSize: 16, fontWeight: 'bold', textDecoration: 'none' }}
//             >
//                 {({ loading, error }) => {
//                     if (error) return 'Error generating PDF'
//                     return loading ? 'Generating PDF...' : '📄 Download PDF Report'
//                 }}
//             </PDFDownloadLink>
//         </div>
//     )
// }
